import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { arraySucursales } from "@/constants/sucursales";

export const FORMATO_SUPER_KOMPRAS = "super-kompras";
export const FORMATO_SURTITIENDA = "surtitienda";
export const FORMATO_ACROPOLIS = "acropolis";

const normalizarLista = (lista = [], formato, categoria = null) =>
  lista.map((sucursal) => ({
    id: `${formato}-${sucursal.division}`,
    nombre: sucursal.nombre,
    division: sucursal.division,
    formato,
    categoria,
    creadoEn: null,
    actualizadoEn: null,
  }));

export const construirSucursalesFallback = () => {
  const {
    sucursalesSk = [],
    sucursalesSkMicro = [],
    sucursalesSurtitienda = [],
    sucursalesAcropolis = [],
  } = arraySucursales;

  return [
    ...normalizarLista(sucursalesSk, FORMATO_SUPER_KOMPRAS, "sk"),
    ...normalizarLista(sucursalesSkMicro, FORMATO_SUPER_KOMPRAS, "sk-micro"),
    ...normalizarLista(sucursalesSurtitienda, FORMATO_SURTITIENDA),
    ...normalizarLista(sucursalesAcropolis, FORMATO_ACROPOLIS),
  ];
};

export const fallbackSucursales = construirSucursalesFallback();

export const filtrarPorFormato = (tiendas, formato) =>
  tiendas.filter((tienda) => tienda.formato === formato);

export const filtrarPorCategoria = (tiendas, categoria) =>
  tiendas.filter((tienda) => tienda.categoria === categoria);

export function useSucursales(opciones = {}) {
  const store = useStore();

  const tiendasStore = computed(() => {
    const tiendas = store.state.tiendas?.tiendas || [];
    return tiendas.length ? tiendas : fallbackSucursales;
  });

  const sucursalesSuperKompras = computed(() =>
    filtrarPorFormato(tiendasStore.value, FORMATO_SUPER_KOMPRAS)
  );
  const sucursalesSuperKomprasGenerales = computed(() =>
    sucursalesSuperKompras.value.filter(
      (tienda) => !tienda.categoria || tienda.categoria === "sk"
    )
  );
  const sucursalesSuperKomprasMicro = computed(() =>
    sucursalesSuperKompras.value.filter(
      (tienda) => tienda.categoria === "sk-micro"
    )
  );

  const sucursalesSurtitienda = computed(() =>
    filtrarPorFormato(tiendasStore.value, FORMATO_SURTITIENDA)
  );

  const sucursalesAcropolis = computed(() =>
    filtrarPorFormato(tiendasStore.value, FORMATO_ACROPOLIS)
  );

  const obtenerPorDivision = (division) =>
    tiendasStore.value.find(
      (tienda) => String(tienda.division) === String(division)
    );

  if (opciones.autoSuscribir !== false) {
    onMounted(() => {
      store.dispatch("tiendas/iniciarSuscripcion");
      if (opciones.recargar !== false) {
        store.dispatch("tiendas/recargarTiendas").catch(() => {});
      }
    });
  }

  return {
    tiendas: tiendasStore,
    sucursalesSuperKompras,
    sucursalesSk: sucursalesSuperKomprasGenerales,
    sucursalesSkMicro: sucursalesSuperKomprasMicro,
    sucursalesSurtitienda,
    sucursalesAcropolis,
    obtenerPorDivision,
    estaCargando: computed(() => store.state.tiendas?.cargando || false),
  };
}

